export enum SidebarRoutes {
  ManageUsers = 'users',
  ManageLodgingPolicy = 'lodging-policy',
  MergeLodgingOptions = 'merge-rooms',
  ExternalAPICalls = 'external-calls',
  ExportJobs = 'export-jobs'
}

export const isSidebarRoute = (location: string): boolean => {
  return Object.values(SidebarRoutes).some(route => location.includes(route));
};

